


















import { Component, Vue } from 'vue-property-decorator'

import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'

@Component({
  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  }
})
export default class BooksSlider extends Vue {
  activeIndex = 0
  swiperOption = {
    // observer: true, // 修改swiper自己或子元素时，自动初始化swiper
    // observeParents: true, // 修改swiper的父元素时，自动初始化swiper
    // initialSlide: 0,
    // spaceBetween: 35,
    // loop: false,
    // effect: 'coverflow',
    // grabCursor: true,
    // centeredSlides: true,
    // slidesPerView: 'auto',
    pagination: {
      el: '.pagination',
    },
    on: {
      slideChange: () => {
        if (this.swiper) {
          this.changeIndex(this.swiper.activeIndex)
        }
      }
    },
  }
  swiperList = [
    { name: '1', img: require('../../assets/img/1.jpg') },
    { name: '2', img: require('../../assets/img/2.jpg') },
    { name: '3', img: require('../../assets/img/3.jpg') },
    { name: '4', img: require('../../assets/img/4.jpg') },
  ]
  paginationList = ['', '', ''];
  get swiper() {
    return (this.$refs.booksSwiper as any).$swiper
  }
  mounted() {
    this.swiper.slideTo(0, 1000, false)
  }
  changeIndex(activeIndex: number) {
    this.activeIndex = activeIndex
  }
}
